// routing
import Routes from 'routes';

// project imports
import Locales from 'components/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'components/RTLLayout';
import Snackbar from 'components/Snackbar';
import ThemeCustomization from 'themes';
import keycloak from './Keycloak';
// auth provider
import APIErrorProvider from 'contexts/ErrorContext';
import ErrorModal from 'components/ErrorModal';
import { ErrorBoundary } from 'components/ErrorBoundary';
import ProfileProvider from 'contexts/ProfileContext';
import { KeycloakProvider } from 'keycloak-react-web';
import { keycloakInit } from './config';
import CustomDashboardConfigProvider from 'contexts/CustomDashboardConfig';
// ==============================|| APP ||============================== //

const App = () => {
    return (
        <APIErrorProvider>
            <KeycloakProvider initOptions={keycloakInit as any} client={keycloak as any}>
                <ProfileProvider>
                    <CustomDashboardConfigProvider>
                        <ThemeCustomization>
                            <RTLLayout>
                                <Locales>
                                    <NavigationScroll>
                                        <ErrorBoundary>
                                            <Routes />
                                            <Snackbar />
                                        </ErrorBoundary>
                                    </NavigationScroll>
                                    <ErrorModal />
                                </Locales>
                            </RTLLayout>
                        </ThemeCustomization>
                    </CustomDashboardConfigProvider>
                </ProfileProvider>
            </KeycloakProvider>
        </APIErrorProvider>
    );
};
export default App;
